import type Pusher from "pusher-js";

export class Subscriber {
  private readonly pusher: Pusher | undefined;
  private readonly subscribedChannels = new Set<string>();

  constructor(pusher?: Pusher) {
    this.pusher = pusher;
  }

  session_id() {
    if (!this.pusher) {
      return null;
    }
    return this.pusher.sessionID.toString();
  }

  /** True when the event was sent by this session and `force_push` is not set — i.e. the handler should skip it. */
  isSelfOriginated(data: Record<string, unknown>): boolean {
    return (
      data.pusher_session_id === this.session_id() && data.force_push !== true
    );
  }

  /**
   * Subscribe to `channel_suffix` once per process. Subsequent calls with the
   * same suffix are no-ops. No unsubscribe path: a subscription keeps firing
   * after navigation, so a handler that fetches must first check that its CV
   * is still in the query cache.
   */
  subscribe<T extends Record<string, unknown>>(
    channel_suffix: string,
    event: string,
    callback: (data: T) => void,
  ) {
    if (this.subscribedChannels.has(channel_suffix) || !this.pusher) {
      return;
    }
    this.subscribedChannels.add(channel_suffix);
    const channel = this.pusher.subscribe(`private-${channel_suffix}`);
    channel.bind(event, callback);
  }
}
